function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "go-back_svg__a",
  d: "M7.385 13.115l1.47 1.468 5.207-5.208-5.208-5.208-1.469 1.468 2.688 2.698H0v2.084h10.073l-2.688 2.698zM16.667 0H2.083A2.083 2.083 0 000 2.083V6.25h2.083V2.083h14.584v14.584H2.083V12.5H0v4.167c0 1.145.927 2.083 2.083 2.083h14.584a2.09 2.09 0 002.083-2.083V2.083A2.09 2.09 0 0016.667 0z"
}));
var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "matrix(-1 0 0 1 21.875 3.125)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "go-back_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#go-back_svg__a"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#FAFAFA",
  mask: "url(#go-back_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-3.125-3.125h25v25h-25z"
})));
function SvgGoBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25"
  }, props), _ref, _ref2);
}
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='25' height='25' viewBox='0 0 25 25'%3e %3cdefs%3e %3cpath id='prefix__a' d='M7.385 13.115l1.47 1.468 5.207-5.208-5.208-5.208-1.469 1.468 2.688 2.698H0v2.084h10.073l-2.688 2.698zM16.667 0H2.083C.927 0 0 .938 0 2.083V6.25h2.083V2.083h14.584v14.584H2.083V12.5H0v4.167c0 1.145.927 2.083 2.083 2.083h14.584c1.145 0 2.083-.938 2.083-2.083V2.083C18.75.937 17.812 0 16.667 0z'/%3e %3c/defs%3e %3cg fill='none' fill-rule='evenodd' transform='matrix(-1 0 0 1 21.875 3.125)'%3e %3cmask id='prefix__b' fill='%23fff'%3e %3cuse xlink:href='%23prefix__a'/%3e %3c/mask%3e %3cg fill='%23FAFAFA' mask='url(%23prefix__b)'%3e %3cpath d='M0 0H25V25H0z' transform='translate(-3.125 -3.125)'/%3e %3c/g%3e %3c/g%3e %3c/svg%3e";
export { SvgGoBack as ReactComponent };